import { render, staticRenderFns } from "./DVCAPointCalculator.vue?vue&type=template&id=ba21bf76&"
import script from "./DVCAPointCalculator.vue?vue&type=script&lang=js&"
export * from "./DVCAPointCalculator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports